import { Paper } from "@mui/material"

export const Container = ({ children, isMobile }) => {



    return (
        <>

            <Paper elevation={1} sx={{ padding: 3, height: 'calc(100vh - 200px)', overflow: 'auto' , display: isMobile ? 'none' :'block' }}>
                {children}
            </Paper>

        </>
    )

}